import { Component, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { StartupConfigurationState } from '@platform-frontend/checkout';
import { HslColor } from '@platform-frontend/ui-tools';
import { Observable } from 'rxjs';

@Component({
  selector: 'yat-web-checkout-header',
  templateUrl: './web-checkout-header.component.html',
  styleUrls: ['./web-checkout-header.component.scss']
})
export class WebCheckoutHeaderComponent {
  @Input()
  pictureSource?: string | 'icon-academic' = '';

  @Input()
  title?: string = '';

  @Input()
  subtitle?: string | null = null;

  @Select(StartupConfigurationState.brandingColor)
  brandingColor$: Observable<HslColor | null>;

  readonly greyColor: HslColor = { hue: 0, saturation: 0, lightness: 95 };
  readonly defaultBrandingColor: HslColor = { hue: 0, saturation: 0, lightness: 80 };
}
